import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="bg-primary-500 rounded-2xl px-6 md:px-12 py-12 md:py-16 text-center relative overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-background-50"></div>
            <div className="absolute -bottom-16 -left-16 w-48 h-48 rounded-full bg-background-50"></div>
          </div>

          <div className="relative z-10">
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-background-50 leading-tight">
              Ready to Transform Your Workflow?
            </h2>
            <p className="mt-4 text-primary-100 text-base md:text-lg max-w-xl mx-auto leading-relaxed">
              Access the structured system and start optimizing your purchasing workflow instantly. Designed for speed, clarity, and scalability — no complex setup required.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-background-50 text-primary-600 font-semibold text-sm hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg"
              >
                Go to Itaobuy Spreadsheet System
                <i className="ri-arrow-right-up-line ml-2"></i>
              </a>
              <Link
                to="/itaobuy-spreadsheet-guide"
                className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-600 text-background-50 font-semibold text-sm hover:bg-primary-700 transition-all duration-300 whitespace-nowrap cursor-pointer border border-primary-400"
              >
                Learn More First
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-xs text-foreground-500 max-w-lg mx-auto leading-relaxed">
            This website is an informational resource. No financial guarantees are made. All purchasing decisions are the responsibility of the user. External links open in new tabs and connect to the main platform.
          </p>
        </div>
      </div>
    </section>
  );
}